import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, CardBody, CardFooter, FormGroup, Input, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../layouts/breadcrumbs/BreadCrumbs';
import useHttp from "../../hooks/useHttp";
import Loader from "../../layouts/loader/Loader";
import useAlert from "../../hooks/useAlert";


const PackageAdd = ({closeModal}) => {
    const [server, setServer]                  = useState('');
    const [packageName, setPackageName]        = useState('');
    const [price, setPrice]                   = useState(0);
    const [uploadSpeed, setUploadSpeed]       = useState(0);
    const [downloadSpeed, setDownloadSpeed]   = useState(0);
    const [speedUnit, setSpeedUnit]            = useState('Mbps');
    const [validityInDays, setValidityInDays] = useState(30);

    const [errors, setErrors] = useState({}); // State for validation errors

    const [servers, setServers] = useState([]);

    const { isLoading, error, sendRequest } = useHttp();
    const { alert, successAlert, errorAlert } = useAlert();
    const navigate = useNavigate();


    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => error ? errorAlert(error) : null, [error]);
    const cancelAction = () => {
        closeModal();
        navigate("../list");
    }

    const resetForm = () => {
        setServer(null);
        setPackageName("");
        setPrice(0);
        setUploadSpeed(0);
        setDownloadSpeed(0);
        setSpeedUnit('Mbps');
        setValidityInDays(30);
        setErrors({});
        setIsSubmitted(false);
    };

    const validateForm = () => {
        const newErrors = {};
        if (!server) newErrors.server = "Server is required.";
        if (!packageName.trim()) newErrors.packageName = "Package Name is required.";
        if (!price) newErrors.price = "Price is required.";
        if (!uploadSpeed) newErrors.uploadSpeed = "Upload speed is required.";
        if (!downloadSpeed) newErrors.downloadSpeed = "Download speed is required.";
        if (!speedUnit) newErrors.speedUnit = "Speed unit is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const successAction = (data) => {
        successAlert(`Successfully created Zone with Code: ${data.code}`);
        setIsSubmitted(true);
    };

    const submitAction = async () => {
        if (!validateForm()) return; // Stop submission if validation fails

        const payload = {
            serverCode: server,
            name: packageName,
            fee: price,
            uploadSpeed,
            downloadSpeed,
            speedUnit,
            servicePeriodQuantity: validityInDays,
        };
        const requestConfigData = {
            url: `${process.env.REACT_APP_IBILL_GATEWAY}/platform/api/v1/package`,
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: payload,
        };
        sendRequest(requestConfigData, successAction);
    };

    useEffect(() => {
        sendRequest({ url: `${process.env.REACT_APP_IBILL_GATEWAY}/platform/api/v1/servers?serverType=IRADIUS`, headers: { 'Accept': 'application/json' } }, (data) => setServers(data));
    }, []);

    return (
      <div>
          {alert}
          <BreadCrumbs />
          {isLoading
            ? <Loader />
            : <>
                <CardBody>
                    <Row>
                        <FormGroup className="col-md-3">
                            <Label>Server <span style={{ color: 'red' }}>*</span></Label>
                            <Input type="select"
                                   value={server || ""}
                                   onChange={(e) => setServer(e.target.value)}
                                   required
                            >
                                <option value="">Select</option>
                                {servers.map(each => <option key={each.code} value={each.code}>{each.name}</option>)}
                            </Input>
                            {errors.server && <span style={{ color: 'red' }}>{errors.server}</span>}
                        </FormGroup>

                        <FormGroup className="col-md-6">
                            <Label>Name <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                              type="text"
                              value={packageName}
                              placeholder="Name"
                              onChange={(e) => setPackageName(e.target.value)}
                              required
                            />
                            {errors.packageName && <span style={{ color: 'red' }}>{errors.packageName}</span>}
                        </FormGroup>

                        <FormGroup className="col-md-3">
                            <Label>Price <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                              type="number"
                              value={price}
                              onChange={(e) => setPrice(e.target.value)}
                              required
                            />
                            {errors.price && <span style={{ color: 'red' }}>{errors.price}</span>}
                        </FormGroup>

                        <FormGroup className="col-md-3">
                            <Label>Upload Speed <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                              type="number"
                              value={uploadSpeed}
                              onChange={(e) => setUploadSpeed(e.target.value)}
                              required
                            />
                            {errors.uploadSpeed && <span style={{ color: 'red' }}>{errors.uploadSpeed}</span>}
                        </FormGroup>

                        <FormGroup className="col-md-3">
                            <Label>Download Speed <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                              type="number"
                              value={downloadSpeed}
                              onChange={(e) => setDownloadSpeed(e.target.value)}
                              required
                            />
                            {errors.downloadSpeed && <span style={{ color: 'red' }}>{errors.downloadSpeed}</span>}
                        </FormGroup>

                        <FormGroup className="col-md-3">
                            <Label>Speed Unit</Label>
                            <Input type="select"
                                   value={speedUnit || 'Mbps'}
                                   onChange={(e) => setSpeedUnit(e.target.value)}
                            >
                                <option value="mbps">Mbps</option>
                                <option value="gbps">Gbps</option>
                            </Input>
                            {errors.speedUnit && <span style={{ color: 'red' }}>{errors.speedUnit}</span>}
                        </FormGroup>

                        <FormGroup className="col-md-3">
                            <Label>Validity (in days)</Label>
                            <Input
                              type="number"
                              value={validityInDays}
                              onChange={(e) => setValidityInDays(e.target.value)}
                            />
                        </FormGroup>

                    </Row>
                </CardBody>
                <CardFooter>
                    <Row>
                        <div className="col-md-2">
                            <Button className="btn col-12 btn-block btn-danger"
                                    onClick={cancelAction}>Return</Button>
                        </div>
                        <div className="col-md-7" />
                        <div className="col-md-3">
                            {isSubmitted ? (
                              <Button className="btn col-12 btn-block btn-info"
                                      onClick={resetForm}>Add Another</Button>
                            ) : (
                              <Button className="btn col-12 btn-block btn-success"
                                      onClick={submitAction}>Submit</Button>
                            )}
                        </div>
                    </Row>
                </CardFooter>
            </>}
      </div>
    );
};

PackageAdd.propTypes = {
    closeModal: PropTypes.func, // Make it optional
};

PackageAdd.defaultProps = {
    closeModal: () => {}, // Provide a default no-op function
};

export default PackageAdd;